import {ReactElement} from 'react';
import {ProductVariant} from '@shopify/hydrogen/storefront-api-types';
import ProductMarketplaceItem from '../ProductMarketplaceItem.client';
import ReactModal from 'react-modal';
import VectorIcon from '../VectorIcon';

interface ProductMarketplacePricingModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
  partnerVariants: ReadonlyArray<ProductVariant>;
}

export default function ProductMarketplacePricingModal({
  isOpen,
  onRequestClose,
  partnerVariants,
}: ProductMarketplacePricingModalProps): ReactElement {
  return (
    <ReactModal
      isOpen={isOpen}
      className="modal__content default-modal default-modal-large"
      overlayClassName="modal modal_active"
      shouldCloseOnOverlayClick={true}
      onRequestClose={onRequestClose}
      closeTimeoutMS={300}
    >
      <div
        className="default-modal__close close js-modal-close"
        role="button"
        tabIndex={-1}
        onClick={onRequestClose}
      >
        <VectorIcon iconName="delete-x" />
      </div>
      <div className="default-modal__box">
        <div className="container mb-75">
          <h3 className="title-1 mb-30">Marketplace Pricing</h3>
          <div className="marketing-pricing" id="marketing-pricing">
            {partnerVariants.map((variant: ProductVariant) => (
              <ProductMarketplaceItem
                key={variant.id}
                productVariant={variant}
                hidden={false}
              />
            ))}
          </div>
        </div>
      </div>
    </ReactModal>
  );
}
